import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { ProjectAcceptance } from '@common/types';
import { ICommandBase } from "@Quest/cqrs";
import PortfolioScenarioNavigation from '@Quest/PortfolioScenarios/Components/PortfolioScenarioNavigation.vue';
import { ApproveScenarioCommandV1, ApproveScenarioProjectCommandV1, OptimizeSelectionCommandV1, UpdatePortfolioScenarioCommandV1 } from "@Quest/PortfolioScenarios/Domain/commands-core";
import PortfolioScenariosCommands from '@Quest/PortfolioScenarios/Domain/commands-vue-component';
import PortfolioScenariosQueries from '@Quest/PortfolioScenarios/Domain/queries-vue-component';
import { ApprovalPageReadModel, ApprovalProjectReadModel } from '@Quest/PortfolioScenarios/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        PortfolioNavigation, PortfolioScenarioNavigation
    }
})
export default class ApprovalPage extends mixins(PortfolioScenariosQueries, PortfolioScenariosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
    get scenarioId() { return this.$route.params.scenarioId; }
    get portfolioId()
    {
        if (!this.rm?.PortfolioId)
        {
            throw new Error('PortfolioId is not defined.');
        }
        return this.rm.PortfolioId;
    }


    rm: ApprovalPageReadModel | null = null;
    searchPhrase: string | null = null;
    filter: string = 'All';


    handleApproveScenarioCommand(projectId: string)
    {
        if (confirm("Are you sure you want to approve all changes to projects in this scenario?"))
        {
            this.invokeApproveScenarioCommandV1(this.workspaceId, this.portfolioId, this.scenarioId);
        }
    }

    handleApproveScenarioProjectCommand(projectId: string)
    {
        this.invokeApproveScenarioProjectCommandV1(this.workspaceId, this.portfolioId, this.scenarioId, projectId);
    }

    get projectsView(): ApprovalProjectReadModel[]
    {
        let view = new Array(...this.rm?.Projects ?? []);

        if (this.searchPhrase)
        {
            const phrase = this.searchPhrase.toLowerCase();
            view = view.filter(a => a.Name.toLowerCase().indexOf(phrase) > -1);
        }

        switch (this.filter)
        {
            case 'All':
                return view;

            case 'Accepted':
                return view.filter(a => a.Acceptance === ProjectAcceptance.Accepted);

            case 'Rejected':
                return view.filter(a => a.Acceptance === ProjectAcceptance.Rejected);

            case 'TBD':
                return view.filter(a => a.Acceptance === ProjectAcceptance.TBD);

            default:
        }

        return [];
    }


    mounted()
    {
        document.title = "Portfolio Plan - Approval";
        this.runApprovalPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "ApprovalPageReadModel")
        {
            this.rm = model as ApprovalPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (ApproveScenarioProjectCommandV1.matchType(cmd))
        {
            this.runApprovalPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
            alert("Updated");
        }
        else if (ApproveScenarioCommandV1.matchType(cmd))
        {
            this.runApprovalPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
            alert("Updated");
        }
        else if (UpdatePortfolioScenarioCommandV1.matchType(cmd))
        {
            this.runApprovalPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
        }
        else if (OptimizeSelectionCommandV1.matchType(cmd))
        {
            this.runApprovalPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
        }
    }
}